import '../app.es6';
import angular from 'angular';
import moment from '../../node_modules/moment/moment.js';
// import ga from './services/ga.es6';
/*global
ga
*/

class GA {
  /* @ngInject */
  constructor ($analytics) {
    this.$analytics = $analytics;

    GA.$inject = ['$analytics'];
  }

  pageTrack (path) {
    this.$analytics.pageTrack(path);
  }

  eventTrack (eventAction, options = {}) {
    let eventOptions = {};

    // カスタムディメンションを設定
    eventOptions.dimension4 = moment().format('YYYY-MM-DD');
    if (options.user) {
      let user = options.user;

      Object.assign(eventOptions, { dimension1: user.id, dimension6: user.type });
    }
    if (options.lessonId) {
      eventOptions.dimension3 = options.lessonId;
    }
    if (options.video) {
      let video = options.video;

      Object.assign(eventOptions, { dimension2: video.id, dimension5: video.tag });
    }

    this.$analytics.eventTrack(eventAction, eventOptions);
  }

  setUserCustomDimensions (user) {
    ga('set', 'dimension1', user.id);
    ga('set', 'dimension6', user.type);
  }
}

angular.module('myApp').service('GA', GA);



// WEBPACK FOOTER //
// ./app/services/ga.es6